import type { Workspace } from '../../types/index.js';
import { safeJsonDate } from './date.js';

export const normalizeWorkspace = (data: Workspace<string>): Workspace | null => {
  if (!data) return null;

  return Object.assign(data, {
    createdOn: safeJsonDate(data.createdOn),
  });
};